import React from "react";
import ReactDOM from "react-dom";
import Favicon from "react-favicon";
import { BrowserRouter } from "react-router-dom";
import "./style/main.less";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/appStore";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Favicon url={"/public/img/common/favicon.ico"} />
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
